import moment from 'moment';
import momentTz from 'moment-timezone';

function formatMomentDate(date: string | null, includeHours = false, format = ''): string {
    if (date === null || date === undefined) {
        return '';
    }

    return moment(date).format(format ? format : 'MMM DD, YYYY' + (includeHours ? ', hh:mm A' : ''));
}

function startOfDay(date: Date): Date {
    // @ts-expect-error -- window is not typed
    let offset = window.timeZoneOffset;
    if (offset >= 0) {
        offset = '+' + offset;
    }
    const d = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()} 00:00:00`;
    return moment(`${d}${offset}:00`).utc().toDate();
}

function endOfDay(date: Date): Date {
    // @ts-expect-error -- window is not typed
    let offset = window.timeZoneOffset;
    if (offset >= 0) {
        offset = '+' + offset;
    }
    const d = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()} 23:59:59`;
    return moment(`${d}${offset}:00`).utc().toDate();
}

function localTimeToUserTimezone(date: Date, format = 'MMM DD, YYYY'): string {
    const day = date.getDate().toString();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const monthNameShort = date.toLocaleDateString('en-US', { month: 'short' });

    switch (format) {
        case 'DD/MM/YYYY':
            return `${day.padStart(2, '0')}/${month}/${year}`;
        case 'MM/DD/YYYY':
            return `${month}/${day.padStart(2, '0')}/${year}`;
        case 'YYYY/MM/DD':
            return `${year}/${month}/${day.padStart(2, '0')}`;
        case 'MMM DD, YYYY':
            return `${monthNameShort} ${day}, ${year}`;
    }

    return `${month}/${day.padStart(2, '0')}/${year}`;
}

function timezoneOffsetToIana(timeZoneOffset: number): string {
    const offsetMinutes = timeZoneOffset * 60;
    const possibleTimezones = momentTz.tz.names().filter(tz => moment.tz(tz).utcOffset() === offsetMinutes);

    return possibleTimezones.length ? possibleTimezones[0] || 'UTC' : 'UTC';
}

function datePickerEndOfCurrentDate(): Date {
    const d1 = moment().format('DD/MM/YYYY').split('/');
    const d2 = Date.UTC(Number(d1[2]), Number(d1[1]) - 1, Number(d1[0]));
    const d3 = new Date(d2).setHours(23, 59, 59, 999);
    return new Date(d3);
}

export const TimezoneHelper = {
    formatMomentDate,
    startOfDay,
    endOfDay,
    localTimeToUserTimezone,
    timezoneOffsetToIana,
    datePickerEndOfCurrentDate,
};
